import { render, staticRenderFns } from "./contentDetailLive.vue?vue&type=template&id=0299b70e&"
import script from "./contentDetailLive.vue?vue&type=script&lang=js&"
export * from "./contentDetailLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports